export const ACCOUNT_OVERVIEW_SEARCH_FETCH = 'ACCOUNT_OVERVIEW_SEARCH_FETCH';
export const ACCOUNT_REPORT_SEARCH_FETCH = 'ACCOUNT_REPORT_SEARCH_FETCH';
export const ACCOUNT_GROUPED_CERTIFICATES_FETCH =
  'ACCOUNT_GROUPED_CERTIFICATES_FETCH';
export const ACCOUNT_EECS_OVERVIEW_SEARCH_FETCH =
  'ACCOUNT_EECS_OVERVIEW_SEARCH_FETCH';
export const ACCOUNT_EECS_TOTAL_FETCH = 'ACCOUNT_EECS_TOTAL_FETCH';
export const ACCOUNT_ALL_EECS_FETCH = 'ACCOUNT_ALL_EECS_FETCH';
export const ACCOUNT_CANCEL_GROUPED_CERTIFICATES_FETCH =
  'ACCOUNT_CANCEL_GROUPED_CERTIFICATES_FETCH';
export const SET_EECS_GO_ROWS = 'SET_EECS_GO_ROWS';
